import { Workspace } from '../@types/model/workspace';
import { User } from '../@types/model/user';

export const ROLE_USER = ['ROLE_USER'];
export const ROLE_END_USER = ['ROLE_END_USER'];
export const ROLE_ANY_USER = ['ROLE_USER', 'ROLE_END_USER'];

export const DEVICETYPES_OCR = ['preset:ocr-device-type:meter', 'preset:ocr-device-type:water'];

export const WORKSPACES_AMBAR = 'ambar';

export const WORKSPACES_SUBMETRIKA = 'default';

export const WORKSPACES_REPSOL = 'repsol';
export const WORKSPACES_INGAFOOD = 'inga-food';
export const checkRoles = (user: User | null, roles: string[]) => {
  return roles.filter((r) => {
    if (user?.attributes.roles.includes(r)) return true;
    else return false;
  }).length;
};
export const checkDeviceTypes = (deviceType: string, deviceTypes: string[]) => {
  if (deviceTypes.includes(deviceType)) return true;
  return false;
};
export const checkModules = (workspace: Workspace | null, modules: string[]) => {
  if (modules.includes('orders')) return true;
  return modules.filter((m) => {
    if (workspace?.modules.includes(m)) return true;
    else return false;
  }).length;
};
export const checkWorkspace = (workspace: Workspace | null, workspaceToCheck: string) => {
  if (workspace?.wsStyle) return workspaceToCheck === workspace?.wsStyle;
  else return false;
};
